import {
  START_LOADING,
  END_LOADING,
  FETCH_UNIT_OF_MEASURES,
  FETCH_UNIT_OF_MEASURE,
  CREATE_UNIT_OF_MEASURE,
  UPDATE_UNIT_OF_MEASURE,
  DELETE_UNIT_OF_MEASURE
} from "../actions/constants";

const initialState = {
  isLoading: false,
  unitOfMeasures: [],
  currentUnitOfMeasure: null,
  numberOfPages: 0,
  currentPage: 1
};

const unitOfMeasureReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    
    case END_LOADING:
      return { ...state, isLoading: false };
    
    case FETCH_UNIT_OF_MEASURES:
      return {
        ...state,
        unitOfMeasures: action.payload.unitOfMeasures,
        numberOfPages: action.payload.numberOfPages,
        currentPage: action.payload.currentPage
      };
    
    case FETCH_UNIT_OF_MEASURE:
      return {
        ...state,
        currentUnitOfMeasure: action.payload
      };
    
    case CREATE_UNIT_OF_MEASURE:
      return {
        ...state,
        unitOfMeasures: [...state.unitOfMeasures, action.payload]
      };
    
    case UPDATE_UNIT_OF_MEASURE:
      return {
        ...state,
        unitOfMeasures: state.unitOfMeasures.map((uom) => 
          uom._id === action.payload._id ? action.payload : uom
        ),
        currentUnitOfMeasure: action.payload
      };
    
    case DELETE_UNIT_OF_MEASURE:
      return {
        ...state,
        unitOfMeasures: state.unitOfMeasures.filter((uom) => uom._id !== action.payload),
        currentUnitOfMeasure: null
      };
    
    default:
      return state;
  }
};

export default unitOfMeasureReducer;
